import repeatController from './repeaterController'
import template from './index.html'
import QuantityOnHandFieldController from '../../../../../ui-formly/controllers/QuantityOnHandFieldController'

const formly = {
  key: 'Locations',
  name: 'Locations',
  controller: repeatController,
  templateUrl: template,
  templateOptions: {
    addText: 'Add Parts',
    fields: [
      {
        key: 'PartNumber',
        type: 'gridReadonly',
        className: 'col-xs-2'
      },
      {
        key: 'PartDescription',
        type: 'gridReadonly',
        className: 'col-xs-2'
      },
      {
        key: 'Shelf',
        type: 'gridInput',
        className: 'col-xs-2',
        templateOptions: {
          required: true
        }
      },
      {
        key: 'Bin',
        type: 'gridInput',
        className: 'col-xs-2',
        templateOptions: {
          required: true
        }
      },
      {
        key: 'Quantity',
        name: 'Quantity',
        type: 'gridInput',
        controller: QuantityOnHandFieldController,
        templateOptions: {
          min: 0,
          type: 'number',
          required: true
        },
        validators: {
          max: {
            expression: ($viewValue, $modelValue, scope) => {
              const partId = scope.model.PartId
              const newPartQuantity = $modelValue
              const oldPartQuantity = scope.model.Quantity || 0
              const adjustment = newPartQuantity - oldPartQuantity
              const getQuantityByPartId = findClosest('getQuantityByPartId', scope)
              const usedQuantity = getQuantityByPartId(partId) + adjustment
              const maxQuantity = scope.model.QuantityOnHand
              return usedQuantity <= maxQuantity
            },
            message: '"exceeded allowed quantity"'
          }
        },
        watcher: {
          expression: (field, scope) => {
            const partId = scope.model.PartId
            const getQuantityByPartId = findClosest('getQuantityByPartId', scope)
            return getQuantityByPartId(partId)
          },
          listener: (field, quantityUsed, oldValue, scope) => {
            const maxQuantity = scope.model.QuantityOnHand
            const available = maxQuantity - quantityUsed
            const fieldQuantity = scope.model.Quantity || 0

            const max = fieldQuantity + available
            field.templateOptions.helpText = `Max: ${max}`
            field.templateOptions.max = max
          }
        },
        className: 'col-xs-2'
      }
    ]
  }
}

function findClosest(key, scope) {
  if (!key || !scope) {
    return null
  }

  if (Object.prototype.hasOwnProperty.call(scope, key)) {
    return scope[key]
  }

  return findClosest(key, scope.$parent)
}

export default formly